import * as React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { AgencyIcons } from '../../../components/AgencyBrandingAsideCard';
import { selectAgentLevelInfo } from '../../../selectors';

export const AgencyBrandingIconsContainer: React.FC = () => {
  const agentLevelInfo = useSelector(selectAgentLevelInfo, shallowEqual);

  if (!agentLevelInfo) {
    return null;
  }

  const { levelName, levelOrder } = agentLevelInfo;

  return <AgencyIcons levelName={levelName} levelOrder={levelOrder} />;
};
